export * from './sincronizador-equipamento-historico.enum';
